import { action } from 'satcheljs';
import { addDatapointConfig } from 'owa-analytics-actions';
import { FolderForestTreeType } from 'owa-favorites-types';
import { isFeatureEnabled } from 'owa-feature-flags';

export default action('onNewsNodeClicked', (treeType: FolderForestTreeType, unseenCount: number) =>
    addDatapointConfig(
        {
            name: 'NewsNodeClicked',
            customData: {
                view: isFeatureEnabled('tri-newsCompact') ? 'Compact' : 'Regular',
                treeType: treeType,
                notificationCount: unseenCount,
            },
        },
        {
            treeType,
        }
    )
);
